// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
    border-radius: 5px;
    padding: 4px 5px;
    margin: 5px;
    font-size: 16px;
    align-self: center;
    color: white;
    background-color: var(--button-color-primary);
    cursor: pointer;
    border: 1px solid var(--button-color-primary);
}

button.secondary {
    color: white;
    background-color: var(--button-color-secondary);
    border-color: var(--button-color-secondary);
}

button.secondary:hover {
    color: var(--button-color-secondary);
    background-color: var(--button-color-secondary-hover);
}

button.inline, button.textbtn, button.rowbtn {
    margin-top: 0px;
    margin-bottom: 0px;
}

button.inline {
    margin-left: 5px;
}

button.textbtn {
    font-size: 16px;
    margin-left: auto;
}

button.rowbtn {
    font-weight: bold;
    font-size: 16px;
    width: 24px;
    margin-left: auto;
    margin-right: 0;
}

button.edit {
    color: white;
    background-color: var(--button-color-primary);
    border-color: var(--button-color-primary);
}

button.edit:hover {
    color: var(--button-color-primary);
    background-color: var(--button-color-primary-hover);
}

button.success {
    background-color: var(--button-color-success);
    border-color: var(--button-color-success);
    border-radius: 5px;
}

button.success:hover {
    color: var(--button-color-success);
    background-color: var(--button-color-success-hover);
}

button.danger {
    background-color: var(--button-color-danger);
    border-color: var(--button-color-danger);
    border-radius: 5px;
}

button.danger:hover {
    color: var(--button-color-danger);
    background-color: var(--button-color-danger-hover);
}

button.success-alpha {
    color: var(--button-color-success);
    background-color: rgba(255,255,255,0.1);
    border: 1px solid var(--button-color-success-alpha);
}

button.success-alpha:hover {
    color: white;
    background-color: var(--button-color-success);
}

button.danger-alpha {
    color: var(--button-color-danger);
    background-color: rgba(255,255,255,0.1);
    border: 1px solid var(--button-color-danger-alpha);
}

button.danger-alpha:hover {
    color: white;
    background-color: var(--button-color-danger);
}

.upload ::-webkit-file-upload-button {
    background-color: var(--button-color-primary);
    border-radius: 5px;
    color: white;
    border-color: white;
    padding: 5px 5px;
  }`, "",{"version":3,"sources":["webpack://./src/css/button.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,+CAA+C;IAC/C,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,6CAA6C;IAC7C,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,mDAAmD;AACvD;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,mDAAmD;AACvD;;AAEA;IACI,4CAA4C;IAC5C,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,kDAAkD;AACtD;;AAEA;IACI,kCAAkC;IAClC,uCAAuC;IACvC,mDAAmD;AACvD;;AAEA;IACI,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,kDAAkD;AACtD;;AAEA;IACI,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB","sourcesContent":["button {\n    border-radius: 5px;\n    padding: 4px 5px;\n    margin: 5px;\n    font-size: 16px;\n    align-self: center;\n    color: white;\n    background-color: var(--button-color-primary);\n    cursor: pointer;\n    border: 1px solid var(--button-color-primary);\n}\n\nbutton.secondary {\n    color: white;\n    background-color: var(--button-color-secondary);\n    border-color: var(--button-color-secondary);\n}\n\nbutton.secondary:hover {\n    color: var(--button-color-secondary);\n    background-color: var(--button-color-secondary-hover);\n}\n\nbutton.inline, button.textbtn, button.rowbtn {\n    margin-top: 0px;\n    margin-bottom: 0px;\n}\n\nbutton.inline {\n    margin-left: 5px;\n}\n\nbutton.textbtn {\n    font-size: 16px;\n    margin-left: auto;\n}\n\nbutton.rowbtn {\n    font-weight: bold;\n    font-size: 16px;\n    width: 24px;\n    margin-left: auto;\n    margin-right: 0;\n}\n\nbutton.edit {\n    color: white;\n    background-color: var(--button-color-primary);\n    border-color: var(--button-color-primary);\n}\n\nbutton.edit:hover {\n    color: var(--button-color-primary);\n    background-color: var(--button-color-primary-hover);\n}\n\nbutton.success {\n    background-color: var(--button-color-success);\n    border-color: var(--button-color-success);\n    border-radius: 5px;\n}\n\nbutton.success:hover {\n    color: var(--button-color-success);\n    background-color: var(--button-color-success-hover);\n}\n\nbutton.danger {\n    background-color: var(--button-color-danger);\n    border-color: var(--button-color-danger);\n    border-radius: 5px;\n}\n\nbutton.danger:hover {\n    color: var(--button-color-danger);\n    background-color: var(--button-color-danger-hover);\n}\n\nbutton.success-alpha {\n    color: var(--button-color-success);\n    background-color: rgba(255,255,255,0.1);\n    border: 1px solid var(--button-color-success-alpha);\n}\n\nbutton.success-alpha:hover {\n    color: white;\n    background-color: var(--button-color-success);\n}\n\nbutton.danger-alpha {\n    color: var(--button-color-danger);\n    background-color: rgba(255,255,255,0.1);\n    border: 1px solid var(--button-color-danger-alpha);\n}\n\nbutton.danger-alpha:hover {\n    color: white;\n    background-color: var(--button-color-danger);\n}\n\n.upload ::-webkit-file-upload-button {\n    background-color: var(--button-color-primary);\n    border-radius: 5px;\n    color: white;\n    border-color: white;\n    padding: 5px 5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
